export const rankingReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_RANKING_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        rankings: null,
      };
    }
    case "GET_RANKING_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        rankings: action.payload,
      };
    }
    case "GET_RANKING_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        rankings: action.payload,
      };
    }
    case "GET_PROJECT_RANKING_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        projectRankings: null,
      };
    }
    case "GET_PROJECT_RANKING_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        projectRankings: action.payload,
      };
    }
    case "GET_PROJECT_RANKING_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        projectRankings: action.payload,
      };
    }
    case "UPDATE_PROJECT_RANKING_REQUEST": {
      return {
        ...state,
        loading: true,
        projectRankings: null,
      };
    }
    case "UPDATE_PROJECT_RANKING_SUCCESS": {
      return {
        ...state,
        loading: false,
        projectRankings: action.payload,
      };
    }
    case "UPDATE_PROJECT_RANKING_FAILED": {
      return {
        ...state,
        loading: false,
        projectRankings: action.payload,
      };
    }
    case "UPDATE_RANKING_REQUEST": {
      return {
        ...state,
        loading: true,
        ranking: null,
      };
    }
    case "UPDATE_RANKING_SUCCESS": {
      return {
        ...state,
        loading: false,
        ranking: action.payload,
      };
    }
    case "UPDATE_RANKING_FAILED": {
      return {
        ...state,
        loading: false,
        ranking: action.payload,
      };
    }
    case "GET_PROJECT_VIDEO_RANKING_LIST_REQUEST": {
      return { ...state, loading: true, projectVideoRankings: null };
    }
    case "GET_PROJECT_VIDEO_RANKING_LIST_SUCCESS": {
      return { ...state, loading: false, projectVideoRankings: action.payload };
    }
    case "GET_PROJECT_VIDEO_RANKING_LIST_FAILED": {
      return { ...state, loading: false, projectVideoRankings: action.payload };
    }
    case "UPDATE_PROJECT_VIDEO_RANKING_REQUEST": {
      return { ...state, loading: true, projectVideoRankings: null };
    }
    case "UPDATE_PROJECT_VIDEO_RANKING_SUCCESS": {
      return { ...state, loading: false, projectVideoRankings: action.payload };
    }
    case "UPDATE_PROJECT_VIDEO_RANKING_FAILED": {
      return { ...state, loading: false, projectVideoRankings: action.payload };
    }

    default: {
      return state;
    }
  }
};
